import { render } from "./ChannelSelection.vue?vue&type=template&id=02aadb86&scoped=true"
import script from "./ChannelSelection.vue?vue&type=script&lang=js"
export * from "./ChannelSelection.vue?vue&type=script&lang=js"

import "./ChannelSelection.vue?vue&type=style&index=0&id=02aadb86&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02aadb86"]])

export default __exports__